<template>
    <div class="codics-aonaer-info-sys-user-view-user-info-card">
        <div class="codics-aonaer-info-sys-user-view-user-info-card-title">个人信息</div>
        <div class="codics-aonaer-info-sys-user-view-user-info-card-other">
            <div class="codics-aonaer-info-sys-user-view-user-info-card-other-himg-box">
                <el-upload action="cdn.bosscaigou.com" accept="*/image" :http-request="(params) => uploadFile(params)"
                    :limit="1" :show-file-list="false">
                    <div class="codics-aonaer-info-sys-user-view-user-info-card-other-himg">
                        <img :src="userInfo?.user?.himg == null ? 'https://cdn.bosscaigou.com/huayuan/img/yasuo_60bc7e65a6d385d503656e12772d226.webp' : ('https://cdn.bosscaigou.com/' + userInfo?.user?.himg)"
                            alt="">
                    </div>
                </el-upload>
            </div>
            <div class="codics-aonaer-info-sys-user-view-user-info-card-other-box">
                <el-input class="codics-aonaer-info-sys-user-view-user-info-card-other-box-input"
                    style="margin-bottom: 20px;" :maxlength="30" clearable placeholder="请输入您的姓名" v-model="nickName"
                    :disabled="nickState">
                    <el-button v-show="nickState" slot="append" icon="el-icon-edit"
                        @click="nickState = false; nickName = userInfo.user.nickname;"></el-button>
                    <el-button v-show="!nickState" style="margin: 0 0 0 0 !important;" slot="append"
                        icon="el-icon-check" @click="updateNickFuc();"></el-button>
                    <el-button v-show="!nickState" style="margin: 0 0 0 0 !important;" slot="append"
                        icon="el-icon-close" @click="nickState = true; nickName = userInfo.user.nickname;"></el-button>
                </el-input>
                <div class="codics-aonaer-info-sys-user-view-user-info-card-other-box-pass-btn"
                    @click="passVisible = true;">
                    修改密码</div>
            </div>
        </div>
        <el-dialog title="修改密码" :close-on-click-modal='false' :visible.sync="passVisible" :append-to-body="true"
            :modal-append-to-body="false" width="80%">
            <el-form :model="updateForm">
                <el-form-item label="原密码" :label-width="formLabelWidth">
                    <el-input v-model="updateForm.o" autocomplete="off" placeholder="请输入原密码..." clearable
                        :maxlength="30" show-password></el-input>
                </el-form-item>
                <el-form-item label="重复原密码" :label-width="formLabelWidth">
                    <el-input v-model="updateForm.opass1" autocomplete="off" placeholder="请输入原密码..." clearable
                        :maxlength="30" show-password></el-input>
                </el-form-item>
                <el-form-item label="现密码" :label-width="formLabelWidth">
                    <el-input v-model="updateForm.n" autocomplete="off" placeholder="请输入现密码..." clearable
                        :maxlength="30" show-password></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="passVisible = false">取 消</el-button>
                <el-button type="primary" @click="updatePassFuc();">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import * as qiniu from 'qiniu-js';
import { randomString } from '@/utils/myutils';
import { updateHimg, updateNick, updatePass, getQiNiuToken } from '@/api';
export default {
    data() {
        return {
            formLabelWidth: '110px',
            passVisible: false,
            nickName: '',
            qiNiuInfo: {
                token: null
            },
            nickState: true,
            updateForm: {

            }
        }
    },
    mounted() {
        this.getTokenFuc();
    },
    methods: {
        async getTokenFuc() {
            let data = await getQiNiuToken();
            if (data.code == 200) {
                this.qiNiuInfo.token = data.uptoken;
            } else {
                this.$message.error(data.message);
            }
        },
        async updateHimgFuc(img) {
            if (img == '' || img == null) {
                this.$message({
                    message: '头像不能为空！',
                    type: 'warning'
                });
                return;
            }
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let data = await updateHimg({ 'img': img });
            loading.close();
            if (data.code == 200) {
                this.$message({
                    message: '更新头像成功！',
                    type: 'success'
                });
                setTimeout(() => {
                    window.location.reload();
                }, 300);
            } else {
                this.$message.error(data.message);
            }
        },
        async updateNickFuc() {
            if (this.nickName == '') {
                this.$message({
                    message: '昵称不能为空！',
                    type: 'warning'
                });
                return;
            }
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let data = await updateNick({ 'name': this.nickName });
            loading.close();
            if (data.code == 200) {
                this.$message({
                    message: '更新昵称成功！',
                    type: 'success'
                });
                setTimeout(() => {
                    window.location.reload();
                }, 300);
            } else {
                this.$message.error(data.message);
            }
            this.nickState = false;
        },
        async updatePassFuc() {
            if (this.updateForm.o == '' || this.updateForm.opass1 == '' || this.updateForm.n == '') {
                this.$message({
                    message: '密码不能为空！',
                    type: 'warning'
                });
                return;
            }
            if (this.updateForm.o != this.updateForm.opass1) {
                this.$message({
                    message: '两次输入的密码不一致！',
                    type: 'warning'
                });
                return;
            }
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let data = await updatePass(this.updateForm);
            loading.close();
            if (data.code == 200) {
                this.$message({
                    message: '更新密码成功！',
                    type: 'success'
                });
                setTimeout(() => {
                    this.$store.dispatch("logout");
                    window.location.reload();
                }, 300);
            } else {
                this.$message.error(data.message);
            }
            this.passVisible = false;
        },
        uploadFile(uploadInfo) {

            let imgPath = 'huayuan/img/' + randomString(10) + '_' + new Date().getTime() + '_' + this.userInfo?.user?.id + '.png';

            const _that = this;
            // 上传文件
            const observer2 = {
                next(res) {
                    // console.log('next: ', res)
                },
                error(err) {
                    // console.log(err)
                },
                complete(res) {

                    _that.updateHimgFuc(res.key);

                }
            }

            const observable2 = qiniu.upload(uploadInfo.file, imgPath, this.qiNiuInfo.token, {}, {
            })

            const subscription2 = observable2.subscribe(observer2) // 上传开始

        },
    },
    computed: {
        ...mapState(['userInfo'])
    }
}
</script>

<style>
.codics-aonaer-info-sys-user-view-user-info-card {
    height: 510px;
    min-height: 470px;
    width: 100%;
    position: relative;
    float: left;
    margin-left: 20px;
    background: #FFF;
}

.codics-aonaer-info-sys-user-view-user-info-card-title {
    height: 70px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    font-size: 22px;
    font-weight: bold;
    color: #333;
    line-height: 90px;
    padding-left: 50px;
}

.codics-aonaer-info-sys-user-view-user-info-card-title::before {
    content: '';
    height: 2px;
    width: 60px;
    position: absolute;
    margin: auto;
    left: 66px;
    bottom: 0;
    background: #ea5b18;
    border-radius: 1px;
}

.codics-aonaer-info-sys-user-view-user-info-card-other {
    height: 360px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-user-view-user-info-card-other-himg-box {
    height: 100%;
    width: 30%;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-user-view-user-info-card-other-himg {
    height: 176px;
    width: 176px;
    position: absolute !important;
    margin: auto;
    top: -90px;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 50%;
    box-sizing: border-box;
    overflow: hidden;
    border: 1px solid #EEE;
    cursor: pointer;
}

.codics-aonaer-info-sys-user-view-user-info-card-other-himg::before {
    content: '修改头像';
    height: 100%;
    width: 100%;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    line-height: 176px;
    text-align: center;
    color: #FFF;
    font-size: 16px;
    background: rgba(0, 0, 0, .5);
    opacity: 0;
    visibility: hidden;
    z-index: 111;
    transition: .3s;
}

.codics-aonaer-info-sys-user-view-user-info-card-other-himg:hover::before {
    opacity: 1 !important;
    visibility: visible !important;
}

.codics-aonaer-info-sys-user-view-user-info-card-other-himg img {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    object-fit: fill;
}

.codics-aonaer-info-sys-user-view-user-info-card-other-himg-box::before {
    content: '点击修改头像';
    height: 40px;
    width: fit-content;
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 150px;
    bottom: 0;
    line-height: 40px;
    text-align: center;
    font-size: 16px;
    color: #333;
}

.codics-aonaer-info-sys-user-view-user-info-card-other-himg-box::after {
    content: '（请上传不小于200*200像素的jpg，png，jpeg格式的图片）';
    height: fit-content;
    width: 70%;
    position: absolute;
    margin: auto;
    left: 0;
    top: 220px;
    right: 0;
    bottom: 0;
    line-height: 18px;
    text-align: center;
    font-size: 14px;
    color: #AAA;
}

.codics-aonaer-info-sys-user-view-user-info-card-other-box {
    height: 100%;
    width: 70%;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-user-view-user-info-card-other-box-input {
    width: 40% !important;
    position: relative;
    float: left;
    left: 50%;
    margin-top: 90px;
    transform: translateX(-50%);
}

.codics-aonaer-info-sys-user-view-user-info-card-other-box-pass-btn {
    height: 40px;
    width: 40%;
    position: absolute;
    margin: auto;
    top: 160px;
    left: 0;
    right: 0;
    line-height: 40px;
    text-align: center;
    font-size: 14px;
    color: #ea5b18;
    background: #FFF;
    border: 1px solid #ea5b18;
    transition: .3s;
    user-select: none;
    -webkit-user-drag: none;
    cursor: pointer;
    border-radius: 3px;
}

.codics-aonaer-info-sys-user-view-user-info-card-other-box-pass-btn:hover {
    color: #FFF;
    background: #ea5b18;
}

@media (max-width:768px) {
    .codics-aonaer-info-sys-user-view-user-info-card-other {
        height: fit-content !important;
    }

    .codics-aonaer-info-sys-user-view-user-info-card-other-himg-box {
        height: 400px !important;
        width: 100% !important;
    }

    .codics-aonaer-info-sys-user-view-user-info-card-other-box {
        height: 300px;
        width: 100%;
    }

    .codics-aonaer-info-sys-user-view-user-info-card-other-box-input {
        width: 80% !important;
    }

    .codics-aonaer-info-sys-user-view-user-info-card-other-box-pass-btn {
        width: 80%;
    }
}
</style>